<template>
    <vPerformanceAttributionComponent :postList="postList" v-if="flag"></vPerformanceAttributionComponent>
</template>
<script>
import vPerformanceAttributionComponent from '../../listComponent/basicdata/performance/performanceAttributionComponent.vue';
export default {
    name: 'performance_attribution',
    components: {
        vPerformanceAttributionComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                config_rid: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>